export const graphColors = [
  '#490B2D',
  '#490B2DBF',
  '#490B2D66',
  '#490B2D30',
  '#490B2D0A',
]
